import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70991aff&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseAutocompleteInput: require('/opt/cargo.front/src/components/base/autocomplete/input.vue').default,BaseAutocompleteList: require('/opt/cargo.front/src/components/base/autocomplete/list.vue').default,RzDropdown: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/dropdown/index.js').default,BaseBottomBar: require('/opt/cargo.front/src/components/base/bottom-bar.vue').default})
